import SubcategoryPage from '@/components/template/SubcategoryPage';

const TokyoRound = () => {
  const products = [
    {
      title: "Tokyo Round Model 1",
      imageSrc: "https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-round/model-1"
    },
    {
      title: "Tokyo Round Model 2",
      imageSrc: "https://images.unsplash.com/photo-1568782987637-963d378332cd?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-round/model-2"
    },
    {
      title: "Tokyo Round Model 3",
      imageSrc: "https://images.unsplash.com/photo-1625591340248-6d472233115c?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-round/model-3"
    },
    {
      title: "Tokyo Round Model 4",
      imageSrc: "https://images.unsplash.com/photo-1654796586436-69130e132ca5?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-round/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Tokyo Round"
      description="Okrogla ogledala z japonsko estetiko. Harmonija oblike in funkcije za minimalistični dizajn vašega doma."
      heroImage="https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default TokyoRound;